import React from "react";
import { FormPageTypeEnum } from "@dev/ee-api/ee-api-models";
import { Typography } from "@dev/ee-components";
import { useTranslation } from "react-i18next";
import { DoubleOptInContentSectionProps } from "./types";

export const DoubleOptInContentSection = (props: DoubleOptInContentSectionProps) => {
    const { t } = useTranslation();
    const { formPageType, activationEmailTemplate, activationSite } = props;

    return (
        <>
            <Typography variant="body1">{`${t('activationemailtemplate')}: ${
                activationEmailTemplate ? activationEmailTemplate : t('default')
            }`}</Typography>
            {formPageType?.[0] === FormPageTypeEnum.DefaultDoubleOptInPage && (
                <Typography variant="body1">{`${t('activationsite')}: ${t('defaultpage')}`}</Typography>
            )}
            {formPageType?.[0] === FormPageTypeEnum.LandingPageDoubleOptInPage && (
                <Typography variant="body1">{`${t('landingpage')}: ${activationSite}`}</Typography>
            )}
            {formPageType?.[0] === FormPageTypeEnum.ExternalWebsiteDoubleOptInPage && (
                <Typography variant="body1">{`${t('externalwebsite')}: ${activationSite}`}</Typography>
            )}
        </>
    )
}